export default __webpack_public_path__ + "static/media/Jost-ExtraBold.d4eb9fee.ttf";